<template>
  <div class="sub_block" :class="{toBeTransparent: isLogin}">
  </div>
</template>

<script>
import { randomString } from '../../utils/utils'
import { Chance } from 'chance'

const chance = new Chance()

export default {
  props: ['interval'],
  data() {
    return {
      top: 0,   /** 坐标X */
      left: 0,  /** 坐标Y */
      moveTop: 0, /** 第一次移动坐标 */
      moveLeft: 0,  /** 第一次移动坐标 */
      moveTop2: 0,  /** 第二次移动坐标 */
      moveLeft2: 0, /** 第二次移动坐标 */
      timmer: null, /** 定时器 */
      head: null,   /** Head元素 */
      chance: chance,
    }
  },
  methods: {
    move(interval = 10) {
      if(this.isLogin) return

      const keyFramesName = randomString(10)
      this.$el.style.animation = `${keyFramesName} ${interval}s 1`
      this.$el.style.animationFillMode = 'forwards'

      // 1. 生成CSS表
      const runkeyframes =` @keyframes ${keyFramesName}{
        0% { transform: translate3d(
                          ${this.left}%, 
                          ${this.top}%, 
                          -50px
                        );
        }
        50% { transform: translate3d(
                            ${this.moveLeft}%,
                            ${this.moveTop}%,
                            -80px
                          );
        }
        100% { transform: translate3d(
                            ${this.moveLeft2}%,
                            ${this.moveTop2}%,
                            -50px
                          );
        }
      }`

      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = runkeyframes;
      // 2. 将表写入程序
      this.head.appendChild(style);

      // 5秒后删除
      setTimeout(() => { this.head.removeChild(style)}, interval*1200)

      // 3. 更新
      this.top = this.moveTop2
      this.left = this.moveLeft2
      this.moveTop = chance.normal({mean: -50, dev: 4})
      this.moveLeft = chance.normal({mean: -50, dev: 18})
      this.moveTop2 = chance.normal({mean: -50, dev: 4})
      this.moveLeft2 = chance.normal({mean: -50, dev: 18})

      setTimeout(this.move, interval * 1000, interval)
    }
  },
  mounted() {
    const randomColor = chance.color({format: 'hex'})
    this.$el.style.backgroundColor = randomColor
    this.$el.style.boxShadow = `0 0 55px 5px ${randomColor}`

    this.head = document.querySelector('head')
    this.top = chance.normal({mean: -50, dev: 4})
    this.left = chance.normal({mean: -50, dev: 18})
    this.moveTop = chance.normal({mean: -50, dev: 4})
    this.moveLeft = chance.normal({mean: -50, dev: 18})
    this.moveTop2 = chance.normal({mean: -50, dev: 4})
    this.moveLeft2 = chance.normal({mean: -50, dev: 18})

    this.$el.style.transform = `translate3d(${this.left}%, ${this.top}%, -50px)`
    setTimeout(this.move, chance.integer({ min: 0, max: 1 * 1000 }), this.interval)
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin
    }
  }
}
</script>

<style lang="less" scoped>
@keyframes toBeTransparent {
  0% {}
  100% { opacity: .0; }
}
.toBeTransparent {
  animation: toBeTransparent .6s ease 0s 1 normal forwards !important;
}

.sub_block {
  overflow: hidden;
  position: absolute;
  top: 50%;
  left: 50%;

  width: 380px;
  height: 450px;
  border-radius: 100vw;
  background-color: rgb(11, 46, 221);
  box-shadow: 0 0 15px 5px rgb(152, 164, 179);

  transform: translate3d(-50%, -50%, -50px);
  
  word-break: break-all; 
  word-wrap: break-word; 

  user-select: none;

  opacity: .5;
}
</style>